import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import Header from "./navigation/Header";
import LeftDrawer from "./navigation/SideNavBar";
import { Navbardata1, Navbardata2 } from "./common/data/Navbardata";
import { ThemeProvider } from "@material-ui/core/styles";
import defaultTheme from "./themes";
import PageRoutes from "./router/PageRoutes";
import WMSLogin from "./pages/WmsLogin/WmsLogin";
import { AppStyles } from "./themes/AppStyles";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { JssProvider } from "react-jss";
import { createGenerateClassName } from "@material-ui/core/styles";
import { get_master_data, userLogout } from "./common";
import MasterDataContext from "./common/contexts/MasterdataContext";
import { useMsal } from "@azure/msal-react";
import { loginRequest, msalConfig } from "./authConfig";
import SkeletonComponent from "./components/SkeletonComponent";
import ActionTypes from "../src/constants/ActionTypes";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import { get_settings } from "./common";
import jwt from 'json-web-token'
import { useHistory } from 'react-router-dom';
import { list_warehouse_master_by_email } from "./common";
import Dashboard from "./pages/dashboard/Dashboard";
import IdleLogoutPopup from "./IdleLogoutPopup";

const App = () => {
  const { instance, accounts } = useMsal();
  const history = useHistory();
  const timerRef = useRef(null);

  let warehouseData = (window.top !== window.self) ?
    JSON.parse('{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}') : JSON.parse(sessionStorage.getItem("warehouseData")) || "";

  let finalNavbar = sessionStorage.getItem("user_type") === 'Customer' ? Navbardata2 : Navbardata1

  const [masterdata, setMasterdata] = React.useState([]);
  const [AccountDetails, setAccountDetails] = React.useState([]);
  const [mainComponentLoading, setMainComponentLoading] = React.useState(false);
  const [DisplayIdlePopup, setDisplayIdlePopup] = React.useState(false);

  const [state, setState] = React.useState({
    theme: defaultTheme.default,
    rightDrawerOpen: false,
    navDrawerOpen:
      window &&
        window.innerWidth &&
        window.innerWidth >= defaultTheme.default.breakpoints.values.md
        ? false
        : true,
  });
  const classes = AppStyles();
  const { navDrawerOpen } = state;

  const handleChangeNavDrawer = () => {
    setState({
      navDrawerOpen: !state.navDrawerOpen,
    });
  };

  useEffect(() => {
    if (accounts?.length > 0) {
      setMainComponentLoading(true);
      localStorage.setItem('username', accounts[0].username)
      setAccountDetails({ username: localStorage.getItem('username') })
      sessionStorage.setItem('username', accounts[0].username);
      sessionStorage.setItem('name', accounts[0].name);
      setMainComponentLoading(false);
    }
  }, [accounts]);

  const getClientDetails = async () => {
    let notValidUser = false;

    if (!sessionStorage.getItem('client_id')) {
      notValidUser = true;
    }

    await get_settings().then((data1) => {
      jwt.decode('WAREHOUSE', data1, function (err, clientTenant) {

        jwt.encode('WAREHOUSE', clientTenant.data.client_id, function (err1, client) {
          sessionStorage.setItem('client_id', client)
        })
        jwt.encode('WAREHOUSE', clientTenant.data.tenent_id, function (err2, tenant) {
          sessionStorage.setItem('tenant_id', tenant)
        })
      })

      if (notValidUser) {
        history.go(0);
      }
    });
  }

  useEffect(() => {
    if (window.top !== window.self) {
      if (!sessionStorage.getItem('warehouseData')) {
        sessionStorage.setItem('warehouseData', '{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}');
        console.log('session value of warehouse data', sessionStorage.getItem('warehouseData'));

        let damageObj = {
          warehouse_code: "WHJH003",
          warehouse_name: "IM Section- Jamshedpur",
        };

        let LoginObj = {
          pageType: "userLogin",
          name: sessionStorage.getItem('user_email'),
          password: sessionStorage.getItem('user_email'),
          WmsLogin: true
        };
        let postobj = { email: sessionStorage.getItem('user_email') };
        list_warehouse_master_by_email(postobj, sessionStorage.getItem('token')).then((data) => {

          if (data.Records[0] == null) {
            console.log('errror');
          } else {
            sessionStorage.setItem("user_type", data.Records[0][0].user_type)
            sessionStorage.setItem('warehouseCodes', JSON.stringify(data.Records[0][0].warehouse_codes));
          }
        });

        sessionStorage.setItem("login", JSON.stringify(LoginObj));
        sessionStorage.setItem("warehouseData", JSON.stringify(damageObj));

      } else {
        warehouseData = JSON.parse(sessionStorage.getItem("warehouseData"))
      }

    }
    getClientDetails()

    if (JSON.parse(sessionStorage.getItem("login")) !== null) {
      setMainComponentLoading(true);
      let queryParam = {
        warehouse_code: warehouseData.warehouse_code
      }
      get_master_data(queryParam).then((masterdata) => {
        setMasterdata(masterdata);
      });

      setMainComponentLoading(false);
    }

    if (window.location.hostname === 'localhost') {
      document.title = 'Local - Warehouse'
    }
  }, []);

  useEffect(() => {
    if (JSON.parse(sessionStorage.getItem("login")) !== null) {
      if (warehouseData.warehouse_name.includes("Agrico")) {
        for (let each of finalNavbar.menus) {
          if (sessionStorage.getItem("user_type") != 'Customer' && each.text === "Masters") {
            each.subMenus.push({
              text: "Material Group Master",
              link: `/${ActionTypes.LOB}` + "/masters/listmaterialgroupmaster",
            })
          }
          if (each.text === "Reports") {
            each.subMenus.push({
              text: "Agrico Report",
              link: `/${ActionTypes.LOB}` + "/agricoreport",
            },
              {
                text: "SMD Report",
                link: `/${ActionTypes.LOB}` + "/smdreport",
              })
          }
        }
      }

      if (sessionStorage.getItem("user_type") != 'Customer' && warehouseData.warehouse_code == "WHJH003") {
        for (let each of finalNavbar.menus) {
          if (each.text === "Masters") {
            each.subMenus.push({
              text: "Receipt Type Master",
              link: `/${ActionTypes.LOB}` + "/masters/receipttypemaster",
            })
          }
        }
      }

      if (warehouseData.warehouse_name.includes("Bonded")) {
        for (let each of finalNavbar.menus) {
          if (sessionStorage.getItem("user_type") != 'Customer' && each.text === "Masters") {
            each.subMenus.push({
              text: "Form A",
              link: `/${ActionTypes.LOB}` + "/forma",
            },
              {
                text: "Form B",
                link: `/${ActionTypes.LOB}` + "/formb",
              },
              {
                text: "CHAIL Master > Space Certificate",
                link: `/${ActionTypes.LOB}` + "/masters/list-cha-master",
              })
          }
          if (each.text === "Reports") {
            each.subMenus.unshift({
              text: "Bonded WH Stock Report",
              link: `/${ActionTypes.LOB}` + "/stockreport",
            })
          }
        }
      }

      if (warehouseData.warehouse_name.includes("RM Warehouse") || warehouseData.warehouse_name.includes("Material Management")) {
        for (let each of finalNavbar.menus) {
          if (each.text === "Reports") {
            each.subMenus.unshift({
              text: "Stock Report",
              link: `/${ActionTypes.LOB}` + "/stockreportrm",
            })
          }
        }
      } else if (warehouseData.warehouse_name.includes("Extended")) {
        for (let each of finalNavbar.menus) {
          if (each.text === "Reports") {
            each.subMenus.unshift({
              text: "Extended WH Stock Report",
              link: `/${ActionTypes.LOB}` + "/stockreportexwh",
            })
          }
        }
      } else if (warehouseData.warehouse_name.includes("Pravesh")) {
        for (let each of finalNavbar.menus) {
          if (each.text === 'Purchase Order') {
            each.text = 'Release Order'
          }
          if (each.text === "Reports") {
            each.subMenus.unshift({
              text: "Pravesh WH Stock Report", 
              link: `/${ActionTypes.LOB}` + "/stockreport",
            })
          }
          if (each.text === "Masters") {
            each.subMenus.push({
              text: "Vehicle Type Master",
              link: `/${ActionTypes.LOB}` + "/masters/vehicletypemaster",
            })
          }
        }
      } else if (!warehouseData.warehouse_name.includes("Bonded")) {
        for (let each of finalNavbar.menus) {
          if (each.text === "Reports") {
            each.subMenus.unshift({
              text: "Stock Report",
              link: `/${ActionTypes.LOB}` + "/stockreportims",
            })
          }
        }
      }
    }
  }, [sessionStorage.getItem("login")])

  const setMasterObjects = (master_data) => {
    setMasterdata(master_data)
  }

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: false,
  });

  const LoginFunction = async () => {
    if (msalConfig && msalConfig.auth && msalConfig.auth.clientId != null) {
      let resp = await instance.loginRedirect(loginRequest).catch((e) => { });

      if (resp == undefined) {
        window.alert("Invalid Tenant Id")
      }
    } else {
      window.alert(`Session Expired ! - Please, Refresh the Page`)
    }
  };

  useEffect(() => {
    const BEFORE_IDLE_TIMEOUT = 59 * 60 * 1000;
    let idleTimer;

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(onIdle, BEFORE_IDLE_TIMEOUT);
    };

    const onIdle = () => {
      setDisplayIdlePopup(true);
      callingFun('true');
    };

    [
      "mousemove",
      "keydown",
      "mousedown",
      "touchstart",
      "click",
      "keyup",
      "wheel",
    ].forEach((event) => {
      window.addEventListener(event, resetIdleTimer, false);
    });

    resetIdleTimer();

    return () => {
      clearTimeout(idleTimer);
      [
        "mousemove",
        "keydown",
        "mousedown",
        "touchstart",
        "click",
        "keyup",
        "wheel",
      ].forEach((event) => {
        window.removeEventListener(event, resetIdleTimer, false);
      });
    };
  }, []);

  const callingFun = (pasd_key) => {
    timerRef.current = setTimeout(function () {
      setDisplayIdlePopup(false);
      Logout();
    }, 10000);
  };

  const closeConfirmationPopup = async () => {
    setDisplayIdlePopup(false);
  };

  const updateLogout = async () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const Logout = async () => {
    // let myClient = sessionStorage.getItem('client_id');
    // let myTenant = sessionStorage.getItem('tenant_id');
    const postData = {
      token: sessionStorage.getItem("token"),
    };
    const userslogoutresp = await userLogout(postData);
    instance.logoutRedirect({
      postLogoutRedirectUri: `/warehouse`,
    });

    localStorage.clear();
    sessionStorage.clear();
  };

  return (
    <>
      {mainComponentLoading && <SkeletonComponent />}

      <JssProvider generateClassName={generateClassName}>
        <ThemeProvider theme={defaultTheme.default}>
          {warehouseData != "" ? (
            window.top === window.self ? (
              <>
                <Header
                  handleChangeNavDrawer={handleChangeNavDrawer}
                  navDrawerOpen={navDrawerOpen}
                  logout={Logout}
                  warehouseData={warehouseData}
                />
                <LeftDrawer
                  navDrawerOpen={navDrawerOpen}
                  handleChangeNavDrawer={handleChangeNavDrawer}
                  menus={finalNavbar.menus}
                />
                <div
                  className={classNames(
                    classes.container,
                    !navDrawerOpen && classes.containerFull
                  )}
                >
                  <MasterDataContext.Provider value={{ masterdata, setMasterdata }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      {window.top !== window.self && (
                        <Dashboard />
                      )}

                      {window.top === window.self && (
                        <PageRoutes
                          testProps='hello'
                        />
                      )}
                    </MuiPickersUtilsProvider>
                  </MasterDataContext.Provider>
                </div>
              </>
            ) : (
              <>
              <div
                className={classNames(
                  classes.containerDashboard )}
              >
                <MasterDataContext.Provider value={{ masterdata, setMasterdata }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    {window.top !== window.self && (
                      <Dashboard />
                    )}

                    {window.top === window.self && (
                      <PageRoutes
                        testProps='hello'
                      />
                    )}
                  </MuiPickersUtilsProvider>
                </MasterDataContext.Provider>
              </div>
              </> )
          ) :
            ((AccountDetails && AccountDetails.username) || window.top !== window.self) ?
              <WMSLogin
                accounts={AccountDetails}
                setMasterObjects={setMasterObjects}
                logout={Logout}
              /> : <WMSLogin
                LoginFunction={LoginFunction}
              />
          }
        </ThemeProvider>
      </JssProvider>
      {DisplayIdlePopup && (
        <IdleLogoutPopup
          Logout={Logout}
          updateLogout={updateLogout}
          closeConfirmationPopup={closeConfirmationPopup}
        />
      )}
    </>
  );
};

export default App;
